import React from "react";
import classNames from "classnames";
import SearchClient from "../../lib/Restful/SearchClient";
import SelectModal from "./SelectModal";
class SelectButton extends React.Component {
    constructor(props) {
        super(props);
        this.onShow = (event) => {
            if (this.state.data) {
                this.setState({
                    show: true,
                });
            }
            event.preventDefault();
        };
        this.onHide = () => {
            this.setState({
                show: false,
            });
        };
        this.onSubmit = (values) => {
            this.setState({
                values: values,
            });
        };
        this.state = {
            loading: true,
            error: false,
            values: [],
            show: false,
        };
    }
    componentDidMount() {
        SearchClient.get(this.props.uri)
            .then(data => {
            this.setState({
                data: data,
            });
        })
            .catch(error => {
            this.setState({
                error: error,
            });
        })
            .finally(() => {
            this.setState({
                loading: false,
            });
        });
    }
    render() {
        const props = this.props, state = this.state;
        let labels = [];
        if (state.data && state.values.length > 0) {
            state.data.data.map(v => {
                if (state.values.indexOf(v.slug) >= 0) {
                    labels.push(v.name);
                }
            });
        }
        return (React.createElement("div", { className: classNames('search_item', props.classNames) },
            React.createElement("button", { type: "button", className: classNames({ loading: state.loading, 'is-show': state.show, 'is-error': state.error, 'is-empty': state.values.length === 0, 'is-exist': state.values.length > 0 }), disabled: state.loading, onClick: this.onShow },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M14 6H8V0H6v6H0v2h6v6h2V8h6z" })),
                labels.length > 0 ? labels.join('、') : props.children),
            state.data && (React.createElement(React.Fragment, null,
                state.values.length > 0 && (React.createElement("input", { type: "hidden", name: state.data.query, value: state.values.join(',') })),
                React.createElement(SelectModal, { show: state.show, modal: {
                        scrollable: true,
                    }, title: state.data.label, name: state.data.query, multiple: props.multiple, defaultLabel: props.defaultLabel, cols: props.cols, items: state.data.data, values: state.values, onSubmit: this.onSubmit, onHide: this.onHide, comment: props.comment })))));
    }
}
export default SelectButton;
